import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { meta } from 'helpers/decorators'
import { apiCommon, apiTranslationsManagement } from 'helpers/decorators/api'
import { TranslationsManagement as Form } from 'containers/forms/translations-management'
import { Text } from 'components/layout'
import { TranslationsManagementModal } from 'components/modals'


const enhance = compose(
  meta({
    title: 'Translations Management',
    intlKey: 'pageTitle.translationsManagement'
  }),
  apiCommon({ locales: true }),
  apiTranslationsManagement()
)

class TranslationsManagement extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onUpdateTranslations: PropTypes.func,
    onCloseDialog: PropTypes.func,
    isUpdateInProgress: PropTypes.bool
  }
  render() {
    const {
      onSubmit,
      onUpdateTranslations,
      onCloseDialog,
      isUpdateInProgress
    } = this.props

    return (
      <div className="col-xs-12">
        <Text>
          <FormattedMessage
            tagName="p"
            id="translationsManagement.infoLabel"
            defaultMessage="This page allows to import languages from POEditor. Make sure to
          update the strings in POEditor project first and tested it on Customer
          Test environment"
          />
        </Text>
        <Form onSubmit={onSubmit} />
        <TranslationsManagementModal
          isUpdateInProgress={isUpdateInProgress}
          onUpdateTranslations={onUpdateTranslations}
          onCloseDialog={onCloseDialog}
        />
      </div>
    )
  }
}

export default enhance(TranslationsManagement)
